import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BarChart,Bar,XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, PieChart, Pie} from 'recharts';
import {Box, Typography, CircularProgress, MenuItem, FormControl, Select, InputLabel,} from '@mui/material';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const AdminSavedPostAnalytics = () => {
  const [savedPostData, setSavedPostData] = useState([]);
  const [savedPostDataCategory, setsavedPostDataCategory] = useState([]);

  const [loading, setLoading] = useState(true);
  const [timeRange, setTimeRange] = useState('week'); 

  useEffect(() => {
    const fetchSavedPostAnalytics = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `${API_BASE_URL}/api/most-saved-posts?range=${timeRange}`,
          {
            withCredentials: true,
          }
        );
        setSavedPostData(res.data);
        const result = await axios.get(
          `${API_BASE_URL}/api/most-saved-posts-category?range=${timeRange}`,
          {
            withCredentials: true,
          }
        );
        setsavedPostDataCategory(result.data);
      } catch (error) {
        console.error('Error fetching saved post analytics:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSavedPostAnalytics();
  }, [timeRange]);

  const getBarColor = (index) => {
    const colors = ['#993f51', '#255a90', '#649bcb','#ff8c00', '#2e8b57'];
    return colors[index % colors.length];
  };
const getCategoryCounts = (data) => {
  const categoryMap = new Map();

  data.forEach((item) => {
    const categories = item.category || [];
    categories.forEach((cat) => {
      if (!categoryMap.has(cat)) {
        categoryMap.set(cat, 0);
      }
      categoryMap.set(cat, categoryMap.get(cat) + item.saveCount);
    });
  });

  return Array.from(categoryMap.entries()).map(([category, saveCount]) => ({
    category,
    saveCount,
  }));
};

const categoryChartData = getCategoryCounts(savedPostDataCategory);


  return (
    <Box sx={{ p: 4 }}>
       <Box sx={{ display: 'flex', flexDirection: 'row', }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, pr: 2 }}>
      <Typography variant="h5" gutterBottom>
        Most Saved Posts
      </Typography>
      <FormControl sx={{ mb: 3, minWidth: 200 }}>
        <InputLabel id="time-range-label">Time Range</InputLabel>
        <Select
          labelId="time-range-label"
          id="time-range"
          value={timeRange}
          label="Time Range"
          onChange={(e) => setTimeRange(e.target.value)}
        >
          <MenuItem value="day">Last 24 Hours</MenuItem>
          <MenuItem value="week">Last 7 Days</MenuItem>
          <MenuItem value="month">Last 30 Days</MenuItem>
        </Select>
      </FormControl>

      {loading ? (
        <CircularProgress />
      ) : (
        <ResponsiveContainer width="100%" height={500}>
          <BarChart
            layout="vertical"
            data={savedPostData}
            margin={{ top: 20,  bottom: 20 }}
          >
            <XAxis
              type="number"
              label={{
                value: 'Saves',
                position: 'insideBottomRight',
                offset: -10,
              }}
              tickFormatter={(value) => Math.round(value)}
              allowDecimals={false}
              axisLine={false}
              tickLine={false}
            />
            <YAxis
              type="category"
              dataKey="eventName"
              width={200}
              axisLine={false}
              tickLine={false}
            />
            <Tooltip />
            <Bar dataKey="saveCount" radius={[0, 10, 10, 0]}>
              {savedPostData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={getBarColor(index)} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>

        
      )}
      </Box>
  <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, pl: 2 }}>
  <Typography variant="h5" gutterBottom>
    Saved Posts by Tags
  </Typography>
<ResponsiveContainer width="100%" height={400}>
  <PieChart>
    <Tooltip />
    <Pie
      data={categoryChartData}
      dataKey="saveCount"
      nameKey="category"
      cx="50%"
      cy="50%"
      outerRadius={120}
      label={({ name }) => name}  
      labelLine={false}
    >
      {categoryChartData.map((entry, index) => (
        <Cell key={`cell-${index}`} fill={getBarColor(index)} />
      ))}
    </Pie>
  </PieChart>
</ResponsiveContainer>

  </Box>
  </Box>
    </Box>
  );
};

export default AdminSavedPostAnalytics;
